import { useFlyerHeaderViewStyles } from "./flyer-header-view.styles";
import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { FlyerCreateModal } from "../../../../components/flyer-create-modal/flyer-create-modal.component";
import { FlyerHeaderViewProps } from "./flyer-header-view.props";
import { FlyerCreateForm } from "../../../../types/flyer-create-form/flyer-create-form.interface";
import { Header } from "../../../../../../components/headers/header/header.component";
import { IFormValues } from "../../../../../../components/modals/form-modal/form-modal.types";

export const FlyerHeaderView = (props: FlyerHeaderViewProps) => {
  const classes = useFlyerHeaderViewStyles();

  return (
    <>
      <Header
        title="Design Layouts"
        button={{
          action: props.onToggleModal,
          className: classes.addButton,
          disabled: props.isDisabled,
          icon: <AddIcon />,
          title: "New Design Layout",
        }}
      />
      <FlyerCreateModal
        errors={props.errors}
        isOpen={props.isModalOpen}
        onClose={props.onToggleModal}
        onSubmit={(data: IFormValues) => props.onCreateFlyer(data as FlyerCreateForm)}
      />
    </>
  );
};
